import styled from 'styled-components'
import theme from 'theme_'

const { spacing, colors } = theme

export const SubsDetailsPlanBlock = styled.div`
  display: flex;
  border-radius: ${spacing.xs};
  background-color: ${colors.white};
  animation: ${theme.animations.fadeIn} 0.3s ease;
`

export const SubscriptionPlanDescription = styled.div``

export const SubsDetailsPlanImage = styled.div`
  display: none;
  position: relative;
  z-index: 1;
  width: 50%;
  flex-basis: 50%;
  flex-grow: 1;
  flex-shrink: 1;
  justify-content: center;
  align-items: center;
  padding: ${spacing.base} ${spacing.base} ${spacing.md};

  @media ${theme.devices.tablet} {
    display: flex;
  }

  &:before {
    content: '';
    position: absolute;
    top: ${spacing.base};
    left: -1px;
    display: block;
    width: 1px;
    height: calc(100% - (${spacing.base} * 2));
    background-color: ${colors.lightGrey};
  }
`
